module.exports = __webpack_public_path__ + "common/icon-xmark-6af5fa5cd299dd5c1b1b3af5f609ddbb.svg";